export default __webpack_public_path__ + "static/media/ic_not_found.aefae18e.svg";